import { fetchMerchantKeys } from '@basqet-dashboard/common/api';
import { handleQueryError } from '@basqet-dashboard/common/utils';
import { useQuery } from 'react-query';

const useFetchKeys = () => {
  const { isLoading, data, isError, refetch, error } = useQuery(
    'allMerchantKeys',
    fetchMerchantKeys
  );
  if (isError) {
    handleQueryError(error, 'merchant keys');
  }

  const keys = data?.data ?? { public_key: '', secret_key: '' };

  return { isLoading, keys, refetch };
};

export { useFetchKeys };
